import { LaboratoryIndicatorExaminationMethodDto } from "./laboratory-indicator-examination-method.dto";

export class LaboratoryExaminationMethodDto {
    laboratoryExaminationMethodId: number;
    name: string;
    assignedPerformerUserId: number;
    assignedPerformerUserName: string;
    indicatorExaminationMethods: LaboratoryIndicatorExaminationMethodDto[] = [];
}